import { RtStore } from "src/components/ReactiveTable/RtStore";
import { RefSelectStore } from "src/components/RefSelect/RefSelectStore";
import { ZRole, ZUser } from "src/types";

import { loadRoles } from "../../roles";

export const makeRolesRefStore = (sourceData: ZUser | undefined) =>
  new RefSelectStore<ZRole, {}>({
    tableStore: new RtStore<ZRole, {}>({
      rowKey: "id",
      loader: loadRoles(),
      selectionType: "checkbox",
    }),
    initialOptions: (sourceData?.roles || []).map((role) => ({
      label: role.name,
      value: role.id,
    })),
    renderLabel: (row) => row.name,
  });
